import React, { Component } from 'react'
import axios from 'axios';
import { getAPIHostURL } from '../../ClientConfig';
import { AppRelevantDataContext} from '../../AppContext';
import {QrScanner} from '@yudiel/react-qr-scanner';
import { FaQrcode } from 'react-icons/fa'

export class VcDeviceInstalled extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            input: "",
            devices: [],
            showScanner: false,
            lastScannedDevice: "",
            DevicesStatusRes: [],
            showFailedDevicesModal: false,
            selectedFailedDevices: [],
            selectedFailureReason: "",
            installationDate: "",
            errors: {
                others:"",
            },
        }
    }

    markDeviceAsInstalled = () => {

        let modifiedState = this.state;

        if(modifiedState.devices == null || modifiedState.devices.length <= 0) {
            modifiedState.errors.others = "Please Enter Device Id's";
            this.setState(modifiedState);
            return;
        }
        const confirmRegister = window.confirm("Do you want to install this device(s)?");
            if (!confirmRegister) {
                alert("Device installation cancelled.");
                return;
            }
        
        let jsonParams = {
            DeviceIDs: modifiedState.devices, 
            InstallDateTime: modifiedState.installationDate
        }

        axios.post(`${getAPIHostURL()}/wclient/markDeviceInstall`, jsonParams)
        .then(response => {
            
            if(response.data.code == 'SUCCESS') {
                modifiedState.DevicesStatusRes = [];
                if(response.data.DevicesStatusRes == null || response.data.DevicesStatusRes.length <= 0 
                ) {
                    alert(`Successfully Marked devices as installed.`);

                } else {
                    alert(`Mark Device installed process completed. Please review the results.`);
                }

                modifiedState.DevicesStatusRes = response.data.DevicesStatusRes;

                modifiedState.devices = [];
                modifiedState.input = "";
                modifiedState.showScanner = false;
                modifiedState.installationDate = "";

                modifiedState.errors = {
                    others:"",
                }      
                          
            } else {
                if (response.data.code == 'SQL_ERROR') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else if (response.data.code == 'REQ_PARAMS_MISSING') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues (required parameters not sent). Try again later.';
                }  else if (response.data.code == 'SERVER_EXPERIENCING_ISSUES') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else {
                    console.log('Should not reach here');
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                }
                
            }
            this.setState(modifiedState);
        })
        .catch( error => {

            if (axios.isCancel(error)) {
                console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
            } else {
                // Tell the user that there are network issues
                modifiedState.errors.others = 'Network issues.\nCheck your Internet and Try again later.';
                this.setState(modifiedState);
            }
        }); 
    }

    decideNoteAccordingToPageInvokedFrom = (e) => {

        return(
            <div style={{border: "1px solid #a8cca8", textAlign:"left", borderRadius:"0.5rem", marginBottom:"1rem", paddingTop:"0.5rem"}} >
                <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem"}}>Why this Action might be needed ?</div>
                <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
                    A Device is suitable for marking as Device Installed if it satisfies the following scenarios: 
                    <br/>- The Device should be succesfully installed on the field. 
                    <br/>- The Device should be in 'Mapped to Owner' or 'Mapped as Replacement' State. 
                </div>
                <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem", marginTop:"0.8rem"}}>
                    Who can Perform this Action ?
                </div>
                <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
                    A CRM User having 'FieldEngineer' Privilege.
                </div>
                <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem", marginTop:"0.8rem"}}>
                    What should be the Current State of the Device ?
                </div>
                <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem", marginBottom:"0.5rem"}}>
                    The Device should be in 'Mapped to Owner' or 'Mapped as Replacement' State.
                </div>
            </div>
        )
    }

    partialFailureDevicesBox = (e) => {

        const totalProcessed =
            this.state.DevicesStatusRes.reduce(
                (sum, item) => sum + item.devices.length,
            0
        );

        const successCount =
            this.state.DevicesStatusRes
                .filter(
                    item =>
                        item.reason === "DEVICE_INSTALLED_SUCCESS"
                )
                .reduce(
                    (sum, item) => sum + item.devices.length,
                    0
                );

        const failedCount =
            this.state.DevicesStatusRes
            .filter(
                item =>
                    item.reason !== "DEVICE_INSTALLED_SUCCESS"
            )
            .reduce(
                (sum, item) => sum + item.devices.length,
                0
            );

        const sortedResults = [...this.state.DevicesStatusRes].sort((a, b) => {

            if (
                a.reason === "DEVICE_INSTALLED_SUCCESS"
            ) return -1;

            if (
                b.reason === "DEVICE_INSTALLED_SUCCESS"
            ) return 1;

            return 0;
        });

        const hasFailures = failedCount > 0;
        
        return(
            <div
                style={{
                    // border: "1px solid #d6d6d6",
                    borderRadius: "10px",
                    padding: "0.8rem",
                    marginBottom: "1rem",
                    // background: "#fff", 
                    background:
                        hasFailures
                            ? "#fff8f8"
                            : "#f0fff4",
                                    border:
                        hasFailures
                            ? "1px solid #f5c2c7"
                            : "1px solid #badbcc",
                                        boxShadow:
                        hasFailures
                            ? "0 2px 8px rgba(220, 53, 69, 0.08)"
                            : "0 2px 8px rgba(25, 135, 84, 0.08)"
                                    }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "0.3rem"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px"
                        }}
                    >
                        <span style={{ fontSize: "18px" }}>
                            {hasFailures ? "⚠️" : "✅"}
                        </span>

                        <div
                            style={{
                                fontSize: "1rem",
                                fontWeight: "600"
                            }}
                        >
                           {
                                hasFailures
                                    ? "Check your results"
                                    : "Operation completed successfully"
                            }
                        </div>

                    </div>

                    <span
                        onClick={() => {

                            this.setState({
                                DevicesStatusRes: []
                            });

                        }}
                        style={{
                            cursor: "pointer",
                            fontSize: "1.3rem",
                            fontWeight: "bold",
                            color: "#666"
                        }}
                    >
                        ×
                    </span>
                </div>

                <div
                    style={{
                        marginBottom: "0.5rem",
                        fontSize: "0.9rem",
                        color: "#555",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                   {
                        hasFailures
                            ? "Some device operations failed. Retry them if needed."
                            : "All selected devices were marked as installed successfully."
                    }
                </div>

                <div
                    style={{
                            fontSize: "0.85rem",
                            marginBottom: "10px",
                            padding: "6px 10px",
                            background: "#fff",
                            borderRadius: "6px",
                            border: "1px solid #e9ecef"
                        }}
                    >
                        <strong>Processed:</strong> {totalProcessed}
                        <span style={{ color: "#198754", marginLeft: "15px" }}>
                            {successCount} Success
                        </span>
                        <span style={{ color: "#dc3545", marginLeft: "15px" }}>
                            {failedCount} Failed
                        </span>
                </div>

                <div>
                    {
                        sortedResults.map((item, index) => (

                            <div
                                key={index}
                                style={{
                                    borderBottom:
                                        index !== this.state.DevicesStatusRes.length - 1
                                            ? "1px solid #f0f0f0"
                                            : "none",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: "10px"
                                    }}
                                >

                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            color: item.reason === "DEVICE_INSTALLED_SUCCESS"
                                                ? "#198754"
                                                : "#dc3545",
                                            fontWeight: "400"
                                        }}
                                    >

                                        {/* <span style = {{fontSize: "0.9rem"}}>❌</span> */}

                                        <span style = {{fontSize: "0.9rem"}}>

                                            {
                                                item.reason === "DEVICE_INVALID"
                                                &&
                                                "Invalid Device"
                                            }

                                            {
                                                item.reason === "DEVICE_STATE_INVALID"
                                                &&
                                                "Invalid Device State"
                                            }

                                            {
                                                item.reason === "DEVICE_ALREADY_INSTALLED"
                                                &&
                                                "Device Already Installed"
                                            }

                                            {
                                                item.reason === "DEVICE_INSTALL_UPDATE_FAILED"
                                                &&
                                                "Device Install Update Failed"
                                            }

                                            {
                                                item.reason === "DEVICE_INSTALLED_SUCCESS"
                                                &&
                                                "Successfully Installed"
                                            }

                                            {" ("}
                                            {item.devices.length}
                                            {" devices)"}

                                        </span>
                                    </div>

                                    <span
                                        onClick={() => {
                                            this.setState({

                                                showFailedDevicesModal: true,

                                                selectedFailedDevices: item.devices,

                                                selectedFailureReason: item.reason

                                            });

                                        }}
                                        style={{
                                            color: "#0d6efd",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            fontWeight: "500",
                                            fontSize: "0.9rem",
                                            paddingLeft: "2rem"
                                        }}
                                    >
                                        {
                                            item.reason === "DEVICE_INSTALLED_SUCCESS"
                                                ? "View Successful Devices"
                                                : "View Failed Devices"
                                        }
                                    </span>

                                </div>
                            </div>
                        ))
                    }
                </div>
                 {
                this.state.showFailedDevicesModal &&

                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                >

                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            width: "380px",
                            maxHeight: "55vh",
                            overflowY: "auto",
                            padding: "1.5rem",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)"
                        }}
                    >

                        {/* HEADER */}

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "1rem"
                            }}
                        >

                            <div
                                style={{
                                    fontSize: "1.2rem",
                                    fontWeight: "600"
                                }}
                            >

                                {
                                    this.state.selectedFailureReason === "DEVICE_INVALID"
                                    &&
                                    "Invalid Devices"
                                }

                                {
                                    this.state.selectedFailureReason === "DEVICE_STATE_INVALID"
                                    &&
                                    "Invalid Device State"
                                }

                                {
                                    this.state.selectedFailureReason === "DEVICE_ALREADY_INSTALLED"
                                    &&
                                    "Device Already Installed"
                                }

                                {
                                    this.state.selectedFailureReason === "DEVICE_INSTALL_UPDATE_FAILED"
                                    &&
                                    "Device Install Update Failed"
                                }

                                {
                                    this.state.selectedFailureReason === "DEVICE_INSTALLED_SUCCESS"
                                    &&
                                    "Successfully Installed Devices"
                                }

                            </div>

                            <span
                                onClick={() => {

                                    this.setState({
                                        showFailedDevicesModal: false
                                    });

                                }}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "1.4rem",
                                    fontWeight: "bold"
                                }}
                            >
                                ×
                            </span>

                        </div>

                        <textarea
                            readOnly
                            value={
                                this.state.selectedFailedDevices.join("\n")
                            }
                            style={{
                                width: "100%",
                                minHeight: "160px",
                                resize: "none",
                                border: "1px solid #ced4da",
                                borderRadius: "8px",
                                padding: "12px",
                                fontSize: "14px",
                                outline: "none",
                                // background: "#fff8f8",
                                // color: "#842029",
                                lineHeight: "1.6"
                            }}
                        />

                    </div>

                </div>
            }
            </div>
        )
    }

    addDevices = (values) => {

        const newDevices = values

            // comma
            // spaces
            // newline
            // tabs
            .split(/[\s,]+/)

            .map(item => item.trim())

            .filter(Boolean);

        if (newDevices.length === 0) return;

        this.setState((prevState) => ({

            devices: [
                ...new Set([
                    ...prevState.devices,
                    ...newDevices
                ])
            ],

            input: ""

        }));
    };

    handleChange = (e) => {

        let value = e.target.value;
        let modifiedState = this.state;
        modifiedState.errors.others = "";

        // Remove multiple spaces
        value = value.replace(/\s+/g, " ");

        // Auto-create chips
        if (
            value.includes(",") ||
            value.includes(" ")
        ) {

            const splitValues = value
                .split(/[\s,]+/);

            const completedDevices = splitValues
                .slice(0, -1)
                .join(",");

            const remainingInput =
                splitValues[splitValues.length - 1];

            if (completedDevices) {
                this.addDevices(completedDevices);
            }

            this.setState({
                input: remainingInput
            });

        } else {

            this.setState({
                input: value
            });
        }
    };

    handleKeyDown = (e) => {

        let modifiedState = this.state;
        modifiedState.errors.others = "";

        // Enter key
        if (e.key === "Enter") {

            e.preventDefault();

            const value = this.state.input.trim();

            if (!value) return;

            this.addDevices(value);
        }

        // Remove last chip
        if (
            e.key === "Backspace" &&
            !this.state.input &&
            this.state.devices.length > 0
        ) {

            this.setState((prevState) => ({

                devices: prevState.devices.slice(0, -1)

            }));
        }
    };

    handlePaste = (e) => {

        let modifiedState = this.state;
        modifiedState.errors.others = "";

        const pastedText =
            e.clipboardData.getData("text");

        if (
            pastedText.includes(",") ||
            pastedText.includes("\n") ||
            pastedText.includes(" ") ||
            pastedText.includes("\t")
        ) {

            e.preventDefault();

            this.addDevices(pastedText);
        }
    };

    removeDevice = (device) => {

        let modifiedState = this.state;
        modifiedState.errors.others = "";

        this.setState((prevState) => ({

            devices: prevState.devices.filter(
                item => item !== device
            )

        }));
    };

    handleQrScan = (result) => {

        let modifiedState = this.state;
        modifiedState.errors.others = "";

        if (!result || result.length === 0) return;

        const scannedValue =
            result[0]?.rawValue;

        if (!scannedValue) return;

        // ADD scanned device
        this.addDevices(scannedValue);
    };
        
    render() {
        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="container col-lg-8 col-lg-offset-2
                                              col-md-12">
                        <div className="modal-body p-4 box">
                            <div className = "headingForComponentsOfCrmPage" style={{marginBottom: "1rem"}}>
                                Device Installation
                            </div> 
                            {this.decideNoteAccordingToPageInvokedFrom()}
                            {
                                this.state.DevicesStatusRes &&
                                this.state.DevicesStatusRes.length > 0 &&
                                this.partialFailureDevicesBox()
                            }                            
                            <form onSubmit={this.markDeviceAsInstalled}>
                                <div>
                                    <div>
                                        <div style={{ width: "100%" }}>
                                           <label
                                                className="reg-form-label"
                                                style={{ width: "100%" }}
                                            >
                                                Scan QR Code for Device ID or Enter the same:

                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontSize: "1.2rem",
                                                        fontWeight: "bold",
                                                        marginLeft: "4px"
                                                    }}
                                                >
                                                    *
                                                </span>

                                                {" "}
                                                ({this.state.devices.length} Devices)
                                            </label>
                                            <div
                                                style={{
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "10px",
                                                    padding: "10px",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "8px",
                                                    maxHeight: "250px",
                                                    overflowY: "auto",
                                                    minHeight: "60px",
                                                    alignItems: "center",
                                                    background: "#fff",     
                                                    position: "relative",
                                                    paddingRight: "50px",
                                                }}
                                            >

                                                {this.state.devices.map((device) => (

                                                    <div
                                                        key={device}
                                                        style={{
                                                            background:
                                                                this.state.lastScannedDevice === device
                                                                    ? "#d1e7dd"
                                                                    : "#e7f1ff",
                                                            border:
                                                                this.state.lastScannedDevice === device
                                                                    ? "1px solid #198754"
                                                                    : "1px solid #b6d4fe",
                                                            color: "#084298",
                                                            padding: "6px 12px",
                                                            borderRadius: "20px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            fontSize: "14px"
                                                        }}
                                                    >

                                                        {device}

                                                        <span
                                                            style={{
                                                                cursor: "pointer",
                                                                fontWeight: "bold"
                                                            }}
                                                            onClick={() =>
                                                                this.removeDevice(device)
                                                            }
                                                        >
                                                            ×
                                                        </span>
                                                    </div>
                                                ))}

                                                <input
                                                    type="text"
                                                    value={this.state.input}
                                                    placeholder="Enter or scan device IDs"
                                                    onChange={this.handleChange}
                                                    onKeyDown={this.handleKeyDown}
                                                    onPaste={this.handlePaste}
                                                    style={{
                                                        border: "none",
                                                        outline: "none",
                                                        flex: 1,
                                                        minWidth: "200px",
                                                        fontSize: "14px",
                                                        padding: "6px"
                                                    }}
                                                />

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        this.setState((prevState) => ({
                                                            showScanner:
                                                                !prevState.showScanner
                                                        }))
                                                    }
                                                    style={{
                                                            position: "absolute",
                                                            top: "12px",
                                                            right: "12px",
                                                            border: "none",
                                                            background: "transparent",
                                                            cursor: "pointer",
                                                            fontSize: "22px",
                                                            zIndex: 1000
                                                        }}
                                                    >
                                                        <FaQrcode className = "qrcodeTextBtnIcon"/>                    
                                                </button>
                                            </div>

                                            {
                                                this.state.lastScannedDevice &&
                                                <div
                                                    style={{
                                                        color: "#198754",
                                                        fontSize: "14px",
                                                        marginTop: "8px",
                                                        fontWeight: "600"
                                                    }}
                                                >
                                                    Device scanned:
                                                    {" "}
                                                    {this.state.lastScannedDevice}
                                                </div>
                                            }

                                            {this.state.showScanner && (
                                                <div
                                                    style={{
                                                        marginTop: "20px",
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "320px"
                                                        }}
                                                    >

                                                        <QrScanner
                                                            constraints={{
                                                                facingMode: "environment"
                                                            }}
                                                            onDecode={(result) => {

                                                                console.log("FULL RESULT:", result);

                                                                let scannedValue = "";

                                                                // Handle array response
                                                                if (Array.isArray(result)) {

                                                                    scannedValue =
                                                                        result[0]?.rawValue || "";

                                                                }

                                                                // Handle string response
                                                                else if (typeof result === "string") {

                                                                    scannedValue = result;
                                                                }

                                                                // Handle object response
                                                                else if (result?.rawValue) {

                                                                    scannedValue = result.rawValue;
                                                                }

                                                                if (!scannedValue) return;

                                                                console.log("SCANNED VALUE:", scannedValue);

                                                                this.addDevices(scannedValue);

                                                                this.setState({
                                                                    lastScannedDevice: scannedValue
                                                                });

                                                                setTimeout(() => {

                                                                    this.setState({
                                                                        lastScannedDevice: ""
                                                                    });

                                                                }, 2000);
                                                            }}

                                                            onError={(error) => {
                                                                console.log(error);
                                                            }}
                                                        />
                                                        {/* <button
                                                            type="button"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showScanner: false
                                                                })
                                                            }
                                                            style={{
                                                                marginTop: "10px"
                                                            }}
                                                        >
                                                            Stop Scanner
                                                        </button> */}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ width: "100%", marginTop: "1rem" }}>
                                            <label
                                                className="reg-form-label"
                                                style={{ width: "100%" }}
                                            >
                                                Select Installation Date:
                                            </label>

                                            <input
                                                type="date"
                                                value={this.state.installationDate}
                                                max={new Date().toISOString().split("T")[0]}
                                                onChange={(e) =>
                                                    this.setState({
                                                        installationDate: e.target.value
                                                    })
                                                }
                                                style={{
                                                    width: "100%",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "10px",
                                                    padding: "10px",
                                                    fontSize: "14px",
                                                    background: "#fff",
                                                    outline: "none"
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                marginTop: "1rem"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "1rem"
                                                }}
                                            >
                                                <button
                                                    type={"button"}
                                                    style={{
                                                        borderRadius: "5px",
                                                        width: "20%",
                                                        backgroundColor: "var(--primaryColor)",
                                                        color: "white",
                                                        fontSize: "1.2rem",
                                                        padding: "0.4rem"
                                                    }}
                                                    className="btn-lg"
                                                    onClick={() => this.markDeviceAsInstalled()}
                                                >
                                                    Save
                                                </button>

                                                <button
                                                    type={"button"}
                                                    style={{
                                                        borderRadius: "5px",
                                                        width: "20%",
                                                        backgroundColor: "var(--primaryColor)",
                                                        color: "white",
                                                        fontSize: "1.2rem",
                                                        padding: "0.4rem"
                                                    }}
                                                    className="btn-lg"
                                                    onClick={() =>
                                                        this.setState({
                                                            devices: [],
                                                            input: "",
                                                            showScanner: false
                                                        })
                                                    }
                                                >
                                                    Clear
                                                </button>
                                            </div>                                            
                                        </div>
                                    </div> 
                                </div>
                                <div>
                                    {this.state.errors.others.length > 0 && 
                                        <p style={{paddingTop: "1rem", color:"Red", fontSize:"0.9rem", textAlign:"center"}} className='error'>{this.state.errors.others}</p> 
                                    }   
                                </div>    
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

VcDeviceInstalled.contextType = AppRelevantDataContext; // Default context from which this component will get provider values in required lifecycle methods

export default VcDeviceInstalled;
